export default __webpack_public_path__ + "static/NBInternationalPro-Regular-1408accbd37bc67cfc793f4ea00fb76c.otf";